const cloud = {
    general: {
        onboarding: '入門',
    },
    welcome: {
        page_title: '歡迎',
        title: '歡迎來到 Logto Cloud！我們很想了解你的一些信息。',
        description: '通過更好地了解你，我們可以使你的 Logto 體驗更加個性化。你的信息是安全的。',
        project_field: '我使用 Logto 是為了',
        project_options: {
            personal: '個人專案',
            company: '公司專案',
        },
        title_field: '選擇適用的職稱',
        title_options: {
            developer: '開發人員',
            team_lead: '團隊負責人',
            ceo: 'CEO',
            cto: 'CTO',
            product: '產品',
            others: '其他',
        },
        company_name_field: '公司名稱',
        company_name_placeholder: 'Acme.co',
        company_size_field: '你的公司規模如何？',
        company_options: {
            size_1: '1',
            size_2_49: '2-49',
            size_50_199: '50-199',
            size_200_999: '200-999',
            size_1000_plus: '1000+',
        },
        reason_field: '我註冊的原因是',
        reason_options: {
            passwordless: '尋找無需密碼身份驗證和 UI 工具包',
            efficiency: '尋找即插即用的身份基礎架構',
            access_control: '基於角色和責任控制用戶訪問',
            multi_tenancy: '尋求面向多租戶產品的策略',
            enterprise: '為產品更方便企業使用尋找 SSO 解決方案',
            others: '其他',
        },
    },
    sie: {
        page_title: '定制登錄體驗',
        title: '讓我們輕鬆定制你的登錄體驗',
        inspire: {
            title: '創建引人入勝的示例',
            description: '對登錄體驗不確定嗎？只需點擊“啟發我”，讓魔法發生！',
            inspire_me: '來點靈感',
        },
        logo_field: '應用商標',
        color_field: '品牌顏色',
        identifier_field: '標識符',
        identifier_options: {
            email: '電子郵件',
            phone: '電話',
            user_name: '用戶名',
        },
        authn_field: '身份驗證',
        authn_options: {
            password: '密碼',
            verification_code: '驗證碼',
        },
        social_field: '社交登錄',
        finish_and_done: '完成並完成',
        preview: {
            mobile_tab: '移動端',
            web_tab: '網頁端',
        },
        connectors: {
            unlocked_later: '稍後解鎖',
            unlocked_later_tip: '完成入門流程並進入產品後，你將獲得訪問更多社交登錄方式的權限。',
            notice: '請勿將演示連接器用於生產目的。完成測試後，請刪除演示連接器並使用你的憑證設置自己的連接器。',
        },
    },
    socialCallback: {
        title: '你已成功登錄',
        description: '你已成功使用社交帳戶登錄。為確保與 Logto 的無縫集成並獲得所有功能的訪問權限，我們建議你繼續配置自己的社交連接器。',
    },
    tenant: {
        create_tenant: '創建租戶',
    },
};
export default Object.freeze(cloud);
